import React, { useContext } from "react";
import { FormContext } from "./Form";
import { Informative } from "../../Inputs/General/Index";
import { CurrencyArea } from "./Styles";

export default function Currency({ value, className = "" }) {
  /**
   * @type {{
   *    document:import("types/typedef/documents").DocumentI
   * }}
   */
  const { document } = useContext(FormContext);

  return (
    <>
      {className !== "" ? (
        <div>
          <Informative
            readonly={true}
            label="Moneda"
            value={!value ? document.currency.code : value}
          />
        </div>
      ) : (
        <CurrencyArea>
          <Informative
            readonly={true}
            label="Moneda"
            value={!value ? document.currency.code : value}
          />
        </CurrencyArea>
      )}
    </>
  );
}
